


























































































































































































import { Component, Vue } from "vue-property-decorator";
import api from "@/api";
import {imageUrl, showTagRE} from '@/utils/common'
import {ExportExcel} from "@/utils/exportFile";

@Component({})
export default class AUser extends Vue {

  status = {
    1: '上架',
    0: '下架'
  }
  // 表格数据
  tableData = [];
  // 加载状态
  loading = false;
  // 总条数
  total = 0;
  // 搜索条件
  search: any = {
    keyword: '',
    status: '',
    createTimes: [],
    updateTimes: [],
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };

  toMing(row: any) {
    this.$router.push({
      name: 'pointsMXList',
      query:{
        id: row.id,
        name: row.activityName,
        activityType: row.activityType
      }
    })
  }


  // 日志
  logDialog = false;
  logList = [];
  logTotal = 0;
  listLoading = false;

  lookLogDialog = false;
  openDesc = false
  row = {}
  cancleLog() {
    this.logDialog = false;
  }


  // logTotal = 0
  logSearch = {
    objectId: "",
    objectType: "integral_activity",
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 10, //每页数量
    },
  };
  logTable = [];
  toLog(item: any) {
    this.logSearch.objectId = item.id;
    api.post("J27721", { ...this.logSearch }).then((res) => {
      this.logDialog = true;
      this.logTable = res.list;
      this.logTotal = res.total;
    });
  }

  changeLog(page: any) {
    this.logSearch.pagination.page = page - 1;
    api.post("J27721", { ...this.logSearch }).then((res) => {
      // this.logDialog = true
      this.logTable = res.list;
      this.logTotal = res.total;
    });
  }

  logDetail = false
  toLogDetail(row: any) {
    this.logDetail = true;
    this.row = row;
  }
  CloseLogDetailDialog() {
    this.logDetail = false;
  }


  // 搜索 search:true 重置翻页
  searchTable(search = false) {
    this.loading = true;
    if (search) {
      this.search.pagination = {
        pageSize: 20,
        page: 0,
      };
    }
    this.search.activityId = this.$route.query.id
    api
      .post('J27746', this.search)
      .then(res => {
        this.total = res.total;
        this.tableData = res.list;
      }).finally(() =>{
      this.loading = false;
    })
  }

  // 编辑
  toEdit(row: any) {
    this.$router.push({
      name: 'applet_activity_pointEdit',
      query:{
        id: row.id,
        // hdType: row.activityType,
        activityType: row.activityType,
      }
    })
  }


  setStatus1(row: any) {
    this.$confirm('是否发布上架?' , "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      api
        .post('J27749', {id: row.id})
        .then((res: any) => {
          this.$message.success("操作成功");
          this.searchTable()
        })
    });
  }
    setStatus2(row: any) {
    this.$confirm('是否下架?' , "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      api
        .post('J27750', {id: row.id})
        .then((res: any) => {
          this.$message.success("操作成功");
          this.searchTable()
        })
    });
  }

  // 添加活动
  shopTypeObj = {}
  shopTypeDialog = false
  shopType = ''
  add() {
    this.shopType = ''
    this.shopTypeDialog = true
  }
  cancleShopTypeDialog() {
    this.shopTypeDialog = false
  }
  
  sureShopType() {
    this.shopTypeDialog = false
    this.$router.push({
      name: 'applet_activity_pointEdit',
      query: {
        // hdType: this.shopType,
        activityType: this.shopType,
      }
    })
  }

  config = {}
  getConfig() {
    api.getJavaConfig().then((res) => {
      this.config = res;
    });
  }

  activated() {
    this.getConfig()
    this.searchTable();
  }
}
